import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchCompanyList } from "../../apis/company";

export const fetchCompanyListData = createAsyncThunk(
  "company/fetchCompanyList",
  async (jobId: string, { rejectWithValue }) => {
    try {
      const companyList = await fetchCompanyList(jobId);
      return companyList;
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  }
);
